import { Typography } from "@mui/material";

interface Props {
  text: string;
}

const BlackCardInfo = ({ text }: Props) => {
  return <Typography sx={{ color: "black", fontSize: 15 }}>{text}</Typography>;
};

export default BlackCardInfo;
